import { X } from 'lucide-react';

import type { AssigneeChipProps } from './types';

// ClickUp owns each member's colour, so the chip matches what they already see
// there rather than inventing a second mapping. Only the frame is tinted:
// member colours span the spectrum and coloured label text would be unreadable
// on some of them.
export function AssigneeChip({ name, color, onRemove }: AssigneeChipProps) {
  return (
    <span
      style={
        color
          ? { borderColor: color, backgroundColor: `color-mix(in srgb, ${color} 14%, transparent)` }
          : undefined
      }
      className="inline-flex items-center gap-1 rounded-full border border-control-border px-1.5 text-xs leading-[18px] text-text-secondary"
    >
      {name}
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          aria-label={`Remove assignee ${name}`}
          className="cursor-pointer text-text-tertiary hover:text-text-primary"
        >
          <X className="size-3" />
        </button>
      )}
    </span>
  );
}
